module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/mCe4Ho/tc-custom/9781452102979.jpg?1737757332709",
      "alt": "This image is the cover for the book Slow Cooker: The Best Cookbook Ever with More Than 400 Easy-to-Make Recipes"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Slow Cooker: The Best Cookbook Ever with More Than 400 Easy-to-Make Recipes\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Breakfasts, lunches, dinners, and desserts—at the push of a button—from Huevos Rancheros to Brats ‘n’ Beer, Cajun Chicken Gumbo to Orange-Spiced Coffee.")]), _c('br'), _c('br'), _vm._v("This is the only slow cooker book for busy people. With over four hundred recipes, it saves time and money week after week with easy meals that keep one eating well at home every day. From Old-Fashioned Chicken Pot Pie to Mexican Hot Chocolate Lava Cake, this cookbook contains recipes for everything from soups and roasts to cobblers and puddings, inspiring night after night of great meals. Prep a few ingredients, toss them in the pot, and let the cooker work its magic while you’re gone for the day. Return to a slow-cooked, deeply flavored, great-smelling dinner for you and your family—every night!\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Diane Phillips, James Baigrie\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Diane Phillips is a cooking teacher and author of more than 14 cookbooks. Her home is in San Diego, California.James Baigrie is a New York-based photographer.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Chronicle\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0